import { Text } from "@/components/ui/baseUi/text"
import type { SessionBlockExerciseEntity } from "@/modules/sessions/entities/sessionBlockExerciseEntity"
import { getRpeColor } from "@/modules/sessions/sessionDetails/rpeUtils"
import { type ExerciseFormikType } from "@/modules/sessions/sessionForm/blocks/exerciseBlock/exerciseFormikTypes"
import { word } from "@modules/core/utils/i18n"
import { useMemo } from "react"
import styled from "styled-components"

type RpeTagProps = {
  exercise: ExerciseFormikType | SessionBlockExerciseEntity
  className?: string
} & React.ComponentProps<"div">

export function RpeTag({ exercise, className, ...props }: RpeTagProps) {
  const borderColorRpe = useMemo(() => {
    return getRpeColor(exercise.rpe)
  }, [exercise.rpe])

  return (
    <RpeTagContainer $borderColorRpe={borderColorRpe} className={className} {...props}>
      <Text className="text-textDefault-heading" fontStyle="LL">
        {word("sessionForm.exercise.rpe.label").toUpperCase()} {exercise.rpe}
      </Text>
    </RpeTagContainer>
  )
}

const RpeTagContainer = styled.div<{ $borderColorRpe: string }>`
  display: flex;
  height: 30px;
  padding: 0px 6px;
  align-items: center;
  gap: 10px;
  border-radius: 9px;
  border: ${({ $borderColorRpe }) => ` 1px solid${$borderColorRpe}`};
`
